import { required, minLength, email, sameAs, helpers } from 'vuelidate/lib/validators'


export default {
  name: {
    required,
    minLength: minLength(3)
  },
  email: {
    required,
    email: helpers.regex('name', /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/)
  },
  password: {
    required,
    minLength: minLength(3)
  },
  password_confirmation: {
    required,
    minLength: minLength(3),
    sameAsPassword: sameAs('password')
  }
}